import React from "react";
import { useLocation } from "react-router-dom";
import RegisterPage from "scenes/auth/RegisterPage";
import {
  getCampaignFromLocation,
  isEdekaMeyersCampaign,
} from "utils/campaignCredit";

const EDEKA_MEYERS_STEPS = [
  "Registriere dich oder melde dich an.",
  "Bestätige deine E-Mail-Adresse, falls du noch nicht registriert bist.",
  "Anschließend werden deinem Konto 20 € gutgeschrieben.",
];

const QrRegisterPage = () => {
  const location = useLocation();
  const campaign = getCampaignFromLocation(location);
  const isEdekaOffer = isEdekaMeyersCampaign(campaign);

  return (
    <RegisterPage
      kicker="Registrierung"
      title={
        isEdekaOffer ? (
          <>
            20&nbsp;€ Guthaben<br></br>sichern
          </>
        ) : (
          <>
            Willkommen bei <br></br>
            <em>Dr. Hoffmann</em>
          </>
        )
      }
      lead={
        isEdekaOffer
          ? "Mit der Edeka-Meyers-Aktion erhältst du einmalig 20 € Guthaben für deine nächste Massage."
          : "Registriere dich, um Studio- und Vor-Ort-Termine zu buchen, Buchungen zu verwalten und Erinnerungen per E-Mail zu erhalten."
      }
      introSteps={isEdekaOffer ? EDEKA_MEYERS_STEPS : null}
    />
  );
};

export default QrRegisterPage;
